import { RiVisaLine } from "react-icons/ri";
import { SiMastercard } from "react-icons/si";
import { FaRegCreditCard } from "react-icons/fa";
import { useOutletContext } from "react-router-dom";

export default function PaymentMethod({ paymentMethod, columnDisplay = false, ...rest }) {
    const { mobile} = useOutletContext();
    // Helper function to get card brand icon class
    const getCardBrandIcon = (brand) => {
        switch (brand) {
            case 'visa':
                return <RiVisaLine size={100}/>
            case 'mastercard':
                return <SiMastercard size={100} />
            default:
                return <FaRegCreditCard size={100} />
        }
    }
    if (!paymentMethod) return null;
    return (
        <div className="payment-method-container" {...rest}>
            <div className={`payment-method-content ${columnDisplay || mobile ? 'column-display' : ''}`}>
                {getCardBrandIcon(paymentMethod.card.brand)}
                <p className="card-text">{columnDisplay || mobile ? '****' : '**** **** ****'} {paymentMethod.card.last4}</p>
                <p className="card-text">Expires {paymentMethod.card.exp_month}/{paymentMethod.card.exp_year}</p>
            </div>
        </div>
    )
}